module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\tEn fonction des réponses que vous avez renseigné, voici le profil qui vous correspond le mieux :\n\t\t")]), _vm._v(" "), (_vm.sync) ? _c('div', {
    staticClass: "badge"
  }, [(_vm.profile) ? _c('div', {
    staticClass: "btn btn-white no-click"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgBtn,
      "alt": ""
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.profile) + "\n\t\t\t")]) : _c('div', [_vm._v("\n\t\t\t\tAucune réponse renseigné, veuillez sauvegarder et réessayer à nouveau\n\t\t\t")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c78bbf8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Profil.vue
// module id = 1146
// module chunks = 0